/* Kissura Dringlichkeit im Hero (25.10.).
   Setzt eine rote Pille "Halloween Sale live" vor den Preis/Button und eine rote Zeile
   "Aktion endet bald · Endet in ..." unter den Button. Zeigt nur dann etwas, wenn die
   Event-Leiste eine Aktion aktiv gesetzt hat. Der Countdown nutzt das echte Enddatum der Aktion. */
(function () {
  function init() {
    var act = document.querySelector('.kish__act');
    if (!act || act.getAttribute('data-kis-urg')) return;
    var root = document.documentElement;
    var name = root.getAttribute('data-kis-eventname');
    if (!name) return;
    act.setAttribute('data-kis-urg', '1');

    var pill = document.createElement('p');
    pill.className = 'kish__urg';
    var dot = document.createElement('span');
    dot.className = 'kish__urgdot';
    dot.setAttribute('aria-hidden', 'true');
    var lbl = document.createElement('span');
    lbl.textContent = name === 'halloween' ? 'Halloween Sale live' : 'Aktion live';
    pill.appendChild(dot);
    pill.appendChild(lbl);
    act.insertBefore(pill, act.firstChild);

    var line = document.createElement('p');
    line.className = 'kish__urgline';
    var tx = document.createElement('span');
    tx.textContent = 'Aktion endet bald';
    line.appendChild(tx);

    var endAttr = root.getAttribute('data-kis-eventend');
    var end = endAttr ? new Date(endAttr).getTime() : NaN;
    if (!isNaN(end) && end > Date.now()) {
      var cd = document.createElement('b');
      line.appendChild(cd);
      var p = function (n) { return (n < 10 ? '0' : '') + n; };
      var tick = function () {
        var ms = Math.max(0, end - Date.now()), s = Math.floor(ms / 1000);
        var d = Math.floor(s / 86400), h = Math.floor(s / 3600) % 24, m = Math.floor(s / 60) % 60, x = s % 60;
        cd.textContent = 'Endet in ' + (d > 0 ? d + 'T ' : '') + p(h) + ':' + p(m) + ':' + p(x);
      };
      tick();
      setInterval(tick, 1000);
    }

    var cta = act.querySelector('.kish__cta');
    if (cta) { cta.insertAdjacentElement('afterend', line); } else { act.appendChild(line); }
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
